import { handleAvailable, handleRequest, handleUnavailable } from '../reducerHandlers';
import {
    NETWORK_EXTRA_METADATA_UPDATE,
    NETWORK_FAILURE,
    NETWORK_LOADING,
    NETWORK_SUCCESS,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
    is_connected: null,
    is_internet_reachable: null,
    connection_type: null,
    download_speed_mbps: null,
    latency_ms: null,
    last_check: null,
    loading: false,
    error: null,
    extraMetadata: {},
};

const BANDWIDTH_FILE_SIZE_BYTES = 10385;


// reducer
export const reducer = createReducer(defaultState, {
    [NETWORK_LOADING]: handleRequest,
    [NETWORK_SUCCESS]: handleAvailable,
    [NETWORK_FAILURE]: handleUnavailable,
    [NETWORK_EXTRA_METADATA_UPDATE]: handleExtraMetadataUpdate,
});


// actions
function handleExtraMetadataUpdate(state, { payload: { extraMetadata } }) {
    return {
        ...state,
        extraMetadata: {
            ...state.extraMetadata,
            ...extraMetadata,
        },
    };
}

export function requestBandwidth() {
    return async (dispatch, getState, { services: { dataSource } }) => {
        const startTime = new Date().getTime();
        try {
            await dataSource.requestBandwidth();
            const duration = (new Date().getTime() - startTime) / 1000;
            const speedMbps = (BANDWIDTH_FILE_SIZE_BYTES * 8) / 1024 / 1024 / duration;
            return parseFloat(speedMbps.toFixed(2));
        } catch (error) {
            return null;
        }
    };
}

export function pingAPI() {
    return async (dispatch, getState, { services: { dataSource } }) => {
        const keyState = 'latencyMs'
        const loadingName = 'loading'
        dispatch({ type: NETWORK_LOADING, payload: { loadingName: loadingName } });

        const startTime = new Date().getTime();
        try {
            const response = await dataSource.requestPing();
            const endTime = new Date().getTime();
            const latencyMs = endTime - startTime;
            dispatch({
                type: NETWORK_SUCCESS,
                payload: {
                    keyState: keyState,
                    data: latencyMs,
                    loadingName: loadingName,
                },
                additionalStates: {
                    lastCheck: new Date().toISOString(),
                    error: null,
                },
            });

            return latencyMs;
        } catch (error) {
            dispatch({
                type: NETWORK_FAILURE,
                payload: {
                    keyState: keyState,
                    data: null,
                    loadingName: loadingName,
                },
                additionalStates: {
                    lastCheck: new Date().toISOString(),
                    error: error.message || 'Ping failed',
                },
            });
            return null;
        }
    };
}

export function saveNetworkMetrics(metrics, runtimeMetadata = {}) {
    return async (dispatch, getState, { services: { dataSource } }) => {
        const keyState = 'networkMetricsResponse';
        const loadingName = 'isNetworkMetricsLoading';
        dispatch({
            type: NETWORK_LOADING,
            payload: { loadingName: loadingName },
        });
        try {
            const {
                stores: { currentChain, currentStore },
                network: { extraMetadata },
            } = getState();

            const mergedExtraMetadata = {
                ...(extraMetadata || {}),
                ...(runtimeMetadata || {}),
            };

            let response = await dataSource.saveNetworkMetrics(
                metrics,
                currentChain,
                currentStore,
                JSON.stringify(mergedExtraMetadata),
            );
            dispatch({
                type: NETWORK_SUCCESS,
                payload: {
                    keyState: keyState,
                    data: response,
                    loadingName: loadingName,
                },
                additionalStates: {
                    extraMetadata: {},
                    error: null,
                },
            });
        } catch (error) {
            dispatch({
                type: NETWORK_FAILURE,
                payload: {
                    keyState: keyState,
                    loadingName: loadingName,
                    defaultState: [],
                },
            });
        }
    };
}
